export default {"src":"/_next/static/media/InternalLinkingAILarge.94220f0d.svg","height":42,"width":42};